import React, { useContext, useEffect } from "react";
import { StoreContext } from "../store/Store";
import DashboardBarChart from "../charts/DashboardBarChart";
import DashboardPieChart from "../charts/DashboardPieChart";
import DashboardDonutChart from "../charts/DashboardDonutChart";
import DashboardLineChart from "../charts/DashboardLineChart";
import UnitCountOne from "./child/UnitCountOne";
import RecentOrdersOne from "./child/RecentOrdersOne";
import RecentOrdersTwo from "./child/RecentOrdersTwo";

const CustomMetricComponent = () => {
  const { getCustomMetric, customMetric } = useContext(StoreContext);

  useEffect(() => {
    const configid = localStorage.getItem("configid");
    getCustomMetric(configid);
  }, []);

  console.log(customMetric);
  return (
    <div
      style={{
        minHeight: "81.5vh",
      }}
    >
      <div>
        <p className="mb-0 badge text-lg fw-medium px-10 py-9 radius-4 text-secondary">
          AI Custom Metrics
        </p>
      </div>
      <div className="row row-cols-xl-4 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
        {customMetric.map((item, index) =>
          item.chart_type === "KPI Chart" ? (
            <UnitCountOne data={item} idx={index} />
          ) : null
        )}
      </div>
      <div className="row gy-3 gx-3 mt-1 mb-2">
        {/* SalesStatisticOne */}
        {/* <SalesStatisticOne /> */}
        {customMetric.map((item, index) =>
          item.chart_type === "Line Chart" ? (
            <div className="col-12 col-md-4">
              <DashboardLineChart metricData={item} />
            </div>
          ) : null
        )}
      </div>
      <div className="row gy-3 gx-3 mt-1 mb-2">
        {/* TotalSubscriberOne */}
        {/* <TotalSubscriberOne /> */}
        {customMetric.map((item, index) =>
          item.chart_type === "Bar Chart" ? (
            <div className="col-12 col-md-4">
              <DashboardBarChart metricData={item} />
            </div>
          ) : null
        )}
      </div>
      <div className="row gy-3 gx-3 mt-1 mb-2">
        {/* UsersOverviewOne */}
        {/* <UsersOverviewOne /> */}
        {customMetric.map((item, index) =>
          item.chart_type === "Pie Chart" ? (
            <div className="col-12 col-md-4">
              <DashboardPieChart metricData={item} />
            </div>
          ) : null
        )}
      </div>
      <div className="row gy-3 gx-3 mt-1 mb-2">
        {/* UsersOverviewOne */}
        {/* <UsersOverviewOne /> */}
        {customMetric.map((item, index) =>
          item.chart_type === "Donut Chart" ? (
            <div className="col-12 col-md-4">
              <DashboardDonutChart metricData={item} />
            </div>
          ) : null
        )}
      </div>
      <section className="row gy-3 gx-3 mt-1">
        {customMetric.map((table, index) =>
          table.chart_type === "Table" ? (
            <div className="col-12" key={index}>
              <RecentOrdersTwo table={table} />
            </div>
          ) : null
        )}
      </section>
    </div>
  );
};

export default CustomMetricComponent;
